<mat-toolbar class="mat-primary">
  <span fxFlex>Passwort ändern</span>
  <mat-icon class="cursor-mat-element" (click)="close()">close</mat-icon>
</mat-toolbar>

<ng-template #noPWChange>
  <p>Ihr Passwort können Sie bei ihrem Identity Provider ändern.</p>
</ng-template>

<mat-dialog-content *ngIf="!(dataShareService.isIAMUser$ | async); else noPWChange">
  <form
    [formGroup]="passwordFormGroup"
    (ngSubmit)="confirm()"
    class="form"
    fxLayout="column"
    fxLayoutAlign=" none"
    fxLayoutGap="10px">
    <mat-form-field fxFlex="100" appearance="fill">
      <mat-label>Aktuelles Passwort</mat-label>
      <input matInput [type]="hideCurrentPW ? 'password' : 'text'" formControlName="currentPassword" />
      <mat-icon matSuffix (click)="hideCurrentPW = !hideCurrentPW">
        {{ hideCurrentPW ? 'visibility_off' : 'visibility' }}
      </mat-icon>
      <mat-error
        *ngIf="
          !passwordFormGroup.controls['currentPassword'].valid &&
          passwordFormGroup.controls['currentPassword'].touched
        ">
        Bitte geben Sie Ihr aktuelles Passwort ein.
      </mat-error>
    </mat-form-field>

    <mat-form-field fxFlex="100" appearance="fill">
      <mat-label>Neues Passwort</mat-label>
      <input matInput [type]="hideNewPW ? 'password' : 'text'" formControlName="password" />
      <mat-icon matSuffix (click)="hideNewPW = !hideNewPW">
        {{ hideNewPW ? 'visibility_off' : 'visibility' }}
      </mat-icon>
      <mat-error
        *ngIf="
          !passwordFormGroup.controls['password'].valid && passwordFormGroup.controls['password'].touched
        ">
        {{ validatorsService.getErrorPassword(passwordFormGroup, 'password') }}
      </mat-error>
    </mat-form-field>

    <mat-error *ngIf="error">{{ error }}</mat-error>

    <div class="button-container" fxLayout="row" fxLayoutAlign="end stretch" fxLayoutGap="20px">
      <button mat-stroked-button (click)="close()" color="primary">Abbrechen</button>

      <button mat-raised-button color="primary" type="submit" [disabled]="!passwordFormGroup.valid">
        Passwort ändern
      </button>
    </div>

    <div class="spinner-container" *ngIf="isLoading">
      <mat-spinner diameter="24"></mat-spinner>
    </div>
  </form>
</mat-dialog-content>
